<template>
    <div class="row no-wrap">
        <div>
            {{ $t('formulas') }}
        </div>
        <q-space />
        <q-btn
            flat
            dense
            :aria-label="$t('add_formula')"
            icon="add"
            size="sm"
            color="accent"
            @click="addNewFormula"
        >
            <q-tooltip :delay="1000">
                {{ $t('add_formula') }}
            </q-tooltip>
        </q-btn>
    </div>
    <DndProvider :backend="HTML5Backend" :context="_WINDOW_">
        <transition-group name="list" tag="div">
            <formula-list-element
                v-for="(formula, index) in theModel" 
                :key="(formula as ElementFormula).Id+'_f'"
                v-model="theModel[index]"
                :use-chart-mode="useChartMode"
                :input-index="Number(index)"
                :formula-options="modelValue.filter(el => el.Id !== formula.Id)"
                :allow-hover-action="allowHoverAction"
                :nested-key-name="nestedKeyName"
                :template-name="templateName"
                :parameter-options="parameterOptions"
                @theOnlyFormulaLeft="updateElementName($event, index)"
                @changePosition="moveStoreItem"
                @deleteFormula="deleteFormula(index)"
            />
        </transition-group>
    </DndProvider>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
import FormulaListElement from '@/components/common/formulas-list/FormulaListElement.vue';
import { AnalyticsChartElementFormula, AnalyticsTableFormula } from '@/models/interfaces/entity-settings/parameters/parameters';
import { DndProvider } from 'vue3-dnd';
import { BaseItemTypes } from '@/components/dnd/ItemTypes';

type ElementFormula =  AnalyticsTableFormula | AnalyticsChartElementFormula

@Component({
  name: 'FormulasList',
  components: { FormulaListElement, DndProvider }
})
export default class FormulasList extends Vue {
    @Prop({ default: [] as ElementFormula[] })
    modelValue!: ElementFormula[]
    @Prop({ default: false })
    useChartMode!: boolean
    @Prop({ default: [] })
    parameterOptions?: any[]
    @Prop({ default: '' })
    nestedKeyName!: string
    @Prop({ default: '' })
    templateName!: string

    @Emit("update:modelValue") emitModelValue(arg: ElementFormula[]) { return arg; }
    @Emit("changePosition") emitMoveItem(arg: any) { return arg; }

    // temporary data
    HTML5Backend = require('react-dnd-html5-backend').HTML5Backend
    _WINDOW_ = window

    get theModel() {
      console.log(this.modelValue)
      return this.modelValue
    }

    set theModel(arg: ElementFormula[])
    {
        this.emitModelValue(arg)
    }

    allowHoverAction = (dragParams: any, hoverParams: any) => {
        // reorder on hover between root items of one type only (selections or projections)!
        return dragParams.callbackParams.elType === BaseItemTypes.SELECTED_COLUMN && 
            hoverParams.callbackParams.elType === BaseItemTypes.SELECTED_COLUMN 
    }

    // https request
    async moveStoreItem(params: any) {
        this.emitMoveItem(params)
    }

    // TODO: pass this signal to the parent (FormulasList) and change name there while checking for uniqueness
    updateElementName(val: string, f_index: number) {
        if (!this.theModel || !val || !this.theModel[f_index]) { return }
        if ((this.theModel[f_index] as AnalyticsChartElementFormula).Name.includes(this.$t('new_formula'))) {
            let addition_index = 0
            while (this.theModel.findIndex((el, iff) => el.Name === val+(addition_index ? ''+addition_index : '') && f_index !== iff) !== -1) {
                addition_index++
            }
            console.log('rename to '+val);
            (this.theModel[f_index] as AnalyticsChartElementFormula).Name = val+(addition_index ? ''+addition_index : '');
        }
    }

    // actions
    addNewFormula() {
        let addition_index = 0
        while (this.theModel.findIndex(el => el.Name === this.$t('new_formula')+(addition_index ? ''+addition_index : '')) !== -1) {
            addition_index++
        }

        let last_id = this.theModel && this.theModel.length ? this.theModel.reduce(
            (prev, current) => {
                return prev.Id > current.Id ? prev : current
        }).Id : 0;

        if (this.useChartMode) {
            const new_el: AnalyticsChartElementFormula = {
                Name: this.$t('new_formula')+(addition_index ? ''+addition_index : ''),
                Id: last_id+1,
                Tokens: []
            };
            this.theModel = [ ...this.theModel, new_el ]
        } else {
            const new_el: AnalyticsTableFormula = {
                Name: this.$t('new_formula')+(addition_index ? ''+addition_index : ''),
                Id: last_id+1,
                FormulaTokens: []
            };
            this.theModel = [ ...this.theModel, new_el ]
        }
        console.log(this.theModel)
    }

    deleteFormula(del_index: number) {
        this.theModel.splice(del_index, 1)
    }
}
</script>